import gql from 'graphql-tag'

export const DesiredWeeklyScheduleFieldsFragment = gql`
  fragment DesiredWeeklyScheduleFields on DesiredWeeklySchedule {
    id
    monday
    tuesday
    wednesday
    thursday
    friday
    dropoffAt
    pickupAt
  }
`
